/* eslint-disable no-irregular-whitespace */
export const REGEX_FORMATS = {
  MENTION_USER: /@\[(.*?)]\(data:(.*?)\)/g, // regex to match a username
  BREAK_LINE: /\n/g, // regex to match url
  URL: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g, // regex to match break line \n
  SYMBOLS: /[a-zA-Z0-9`~!@#$%^&*()\-_+={}[/:";'<>.?\]]/,
  KATAKANA: /[Ａ-Ｚァ-ン０-９－，：；（）ー　]/,
}
